// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"6b92c0fd","115":"b5fe1b8e","161":"71712d6c","277":"76f4732d","504":"bf5d1474","590":"78536e0b","643":"b980a2cd","785":"0afaead7"}[chunkId] + ".chunk.js";
};